import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Topbar from './Topbar';
import Sidebar from './Sidebar';
import './layout.css';

const DemoLayout = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  // Routes that should show the full demo layout with navigation
  const demoRoutes = [
    '/jo-xyz-demo/overview',
    '/jo-xyz-demo/connect',
    '/jo-xyz-demo/marketplace',
    '/jo-xyz-demo/asset/',
    '/jo-xyz-demo/assets',
    '/jo-xyz-demo/borrowing-base',
    '/jo-xyz-demo/agents',
    '/jo-xyz-demo/offers',
    '/jo-xyz-demo/accept-offer',
    '/jo-xyz-demo/lender',
    '/jo-xyz-demo/investor',
    '/jo-xyz-demo/list-asset',
    '/jo-xyz-demo/borrower-dashboard',
    '/jo-xyz-demo/lender-dashboard'
  ];

  // Check if current route should show navigation
  const shouldShowNavigation = demoRoutes.some(route => 
    location.pathname.startsWith(route)
  );

  const handleExitDemo = () => {
    history.push('/dashboard');
  };

  // For landing page and onboarding pages, show minimal layout
  if (!shouldShowNavigation) {
    return (
      <div className="jo-xyz-demo">
        <div className="jo-xyz-demo-layout jo-xyz-demo-layout--minimal">
          <Topbar onExitDemo={handleExitDemo} />
          <main className="jo-xyz-demo-main jo-xyz-demo-main--full">
            <div className="jo-xyz-demo-main-content">
              {children}
            </div>
          </main>
        </div>
      </div>
    );
  }

  // For demo pages, show full layout with navigation
  return (
    <div className="jo-xyz-demo">
      <div className="jo-xyz-demo-layout">
        <Topbar onExitDemo={handleExitDemo} />
        <div className="jo-xyz-demo-content">
          <Sidebar />
          <main className="jo-xyz-demo-main">
            <div className="jo-xyz-demo-main-content">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default DemoLayout;
